export const environment = {
  production: false,
  clientId: '9bb56fa8-ea87-4561-8b28-c26a81ada679',
  authority: 'https://asgb2cdevelopment.b2clogin.com/asgb2cdevelopment.onmicrosoft.com/B2C_1A_SEAMLESSMIGRATION_SIGNINANDRESETONLY',
  authorityDomain: 'asgb2cdevelopment.b2clogin.com',
  redirectUri: 'https://usercustomeradmin-dev.asgo.dk/',
  endpoint: 'https://usercustomeradminservice-dev.asgo.dk/',
  endpointScopes: ['https://asgb2cdevelopment.onmicrosoft.com/05841a76-a2ff-4bbe-a580-27822e4055d4/superadmin']
};
